export { default } from './LoadingContainer';



// WEBPACK FOOTER //
// ./src/design-system/molecules/LoadingContainer/index.jsx